// Estilos compartidos entre GenericFilters y cualquier panel de filtros a medida
// (p. ej. FormResponseFieldFilters). Fuente única: si esto cambia, cambian los dos.
export const FILTER_PANEL_CLASSES = 'bg-surface rounded-xl shadow-lg border border-line mb-6';
export const FILTER_FIELD_CLASSES =
  'w-full px-3 py-2.5 text-sm border border-line rounded-lg bg-surface-2 text-content focus:outline-none focus:ring-2 focus:ring-amber';
export const FILTER_LABEL_CLASSES = 'block text-xs font-medium text-content mb-1';
export const FILTER_HEADER_CLASSES = 'flex items-center gap-3';
export const FILTER_HEADER_TITLE_CLASSES = 'text-sm font-medium text-content';
